import React from "react";

function StatiTrasmessiTutti(props) {


    const array = props.array.reverse();



    return (
        <div className="tc">
            <h3>Ultimi ordini trasmessi</h3>
            <div className="">
                {array && array.map((ordine) => <p>{ordine}</p>)}
            </div>
        </div>
    )

}

export default StatiTrasmessiTutti;